export default "__VITE_ASSET__e9lnxXvQ__"